"use client";

import React, { useState } from 'react';
import Link from 'next/link';
import styles from './Footer.module.css'; 

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const subscribe = async (event) => {
    event.preventDefault(); setMessage('');
    const response = await fetch('/api/subscribers', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, source: 'website-footer' }) });
    const result = await response.json(); setMessage(result.message || result.error || 'Subscription request could not be completed.');
    if (response.ok) setEmail('');
  };
  return (
  <footer className={styles.footer}>
    <div className={styles.footerContent}>
      <form className={styles.subscribe} onSubmit={subscribe}><label htmlFor="footer-email">ShuffleDB updates</label><input id="footer-email" type="email" required value={email} onChange={(event) => setEmail(event.target.value)} placeholder="Email address" /><button type="submit">Subscribe</button>{message && <small>{message}</small>}</form>
      <nav className={styles.footerLinks} aria-label="Support and legal links"><Link href="/Support">Help &amp; Support</Link><Link href="/PrivacyPolicy">Privacy</Link><Link href="/TermsOfService">Terms</Link></nav>
      <div className={styles.squareContainer}>
        <div className={styles.colorSquare}></div>
        <span className={styles.screenWidthIndicator}></span>
      </div>
      <p>&copy; 2024 ShuffleDB. All rights reserved.</p>
    </div>
  </footer>
  );
};

export default Footer;
